import { theme } from '@features/lci-report/domain/theme';
import { contentSlideHeader } from '@features/lci-report/utils';
import {
  Slide,
  TextPropsOptions,
  composeSlides,
  parseTags,
} from '@features/powerpoint';
import { TITLE } from '../../../shared/dark-background-slide-master';

const CONTENT_AREA_WIDTH = 11.82;
const TABLE_Y = 2;
const LEFT_MARGIN = 0.74;
const NOTES_Y = TABLE_Y + 3;

const baseSlide = (): Slide => {
  return {
    slideMaster: TITLE,
    texts: [
      contentSlideHeader(parseTags('LCI<sup>®</sup> Guideline Minimums'), {
        color: theme.colors.white,
      }),
    ],
  };
};

type MediumSlideProps = {
  table: Slide;
  buildNotes: (props: { options: TextPropsOptions }) => Slide;
};

export const mediumSlide = (props: MediumSlideProps) =>
  composeSlides(
    baseSlide(),
    props.table,
    props.buildNotes({
      options: {
        x: LEFT_MARGIN,
        y: NOTES_Y,
        h: 3,
        w: CONTENT_AREA_WIDTH,
        valign: 'top',
      },
    })
  );
